import { ID, from } from '@phi/newtype';
import { PropType, defineComponent, h } from 'vue';
import { onshapePartThumbnail } from '@phi/frontend/api/calls';
import { Option } from '@vaaas/fpts/option';
import { data_uri } from '@phi/util/url';
import { OnshapeLogo } from '@components/icons';
import { utility } from '@phi/components';

export default defineComponent({
    props: {
        document: {
            required: true,
            type: null as any as PropType<ID<'document'>>,
        },

        workspace: {
            required: true,
            type: null as any as PropType<ID<'workspace'>>,
        },

        element: {
            required: true,
            type: null as any as PropType<ID<'element'>>,
        },

        part: {
            required: true,
            type: null as any as PropType<ID<'part'>>,
        },

        fetch: {
            required: false,
            type: Function as PropType<typeof onshapePartThumbnail>,
            default: onshapePartThumbnail,
        },
    },

    data() {
        return {
            data_uri: undefined as Option<string>
        };
    },

    mounted() {
        this.fetch(this.document, this.workspace, this.element, this.part, 70)
            .then(x => {
                if (x instanceof Error) return;
                this.data_uri = data_uri('image/png')(from(x.images[0]));
            });
    },

    render() {
        return h('span', { class: 'thumbnail' },
            this.data_uri
                ? h('img', { src: this.data_uri, class: utility.no_interact })
                : OnshapeLogo(false)
        );
    },
});
